import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { isGatsbyLink } from "./helpers";

import ExternalLink from "./external-link";
import InternalLink from "./internal-link";

const Link = (props) => {
  const classes = classNames({
    [props.className]: props.className
  });

  const handleAnchorClick = (e) => {
    const element = document.getElementById(props.to.substring(1));
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    e.preventDefault();
    return false;
  };

  if ((props.to || "")[0] === "#" && !["#login", "#logout"].includes(props.to)) {
    return (
      <a className={classes} onClick={handleAnchorClick} href={props.to}>
        {props.children}
      </a>
    );
  } else if (isGatsbyLink(props.to)) {
    return <InternalLink className={classes} {...props} />;
  } else {
    return <ExternalLink className={classes} {...props} />;
  }
};

Link.propTypes = {
  activeClassName: PropTypes.string,
  activeStyle: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  className: PropTypes.string,
  target: PropTypes.string,
  to: PropTypes.string.isRequired,
  onClick: PropTypes.func
};

Link.defaultProps = {
  target: "_blank"
};

export default Link;
